import { Block as e } from "../../components/FocusBlock.es.js";
import t from "react";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
// lib/TTVisual/components/TTVisualWrapper.tsx
var i = ({ children: i, element: a, editor: o, options: s }) => {
	let c = s?.removable ?? !0, l = (e) => e?.props?.children?.props?.element?.type ? e.props.children.props.element.type : "", u = [], d = [], f = [];
	return t.Children.toArray(i).forEach((e) => {
		let t = l(e);
		t.includes("text") ? u.push(e) : t.includes("byline") ? d.push(e) : f.push(e);
	}), /* @__PURE__ */ n(e, {
		editor: o,
		element: a,
		removable: c,
		children: /* @__PURE__ */ r("figure", {
			className: "relative flex gap-1 flex-col min-h-10",
			children: [
				f,
				u.map((e, t) => /* @__PURE__ */ n("div", { children: e }, t)),
				d.map((e, t) => /* @__PURE__ */ n("div", { children: e }, t))
			]
		})
	});
};
export { i as TTVisualWrapper };
